import React, { useEffect, useState } from 'react';
import StatCard from './Components/StatCard';

import './LeadxchangeDashboard.scss';
import DonutChart from './Components/DonutChart';
import AgentTable from './Components/AgentTable';
import RecentLeadTable from './Components/RecentLeadTable';
import StaleLeadsTable from './Components/StaleLeadsTable';
import BarChart from './Components/BarChart';
import { showError } from '../../../../../Helper';
import { GetDashboardSummary } from '../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { Spinner } from '../../../../../Components';

const LeadxchangeDashboard = ({ filter }) => {
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const getDashboardSummary = async () => {
    setLoading(true);
    try {
      const result = await GetDashboardSummary(filter);
      setDashboardData(result);
    } catch {
      showError('something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDashboardSummary();
  }, [filter]);

  const {
    totalSharedLeads = 0,
    claimedLeads = 0,
    transactedLeads = 0,
    avgClaimTime,
    leadPoolHealth,
    transactedPercentage,
    sourceDistribution = [],
    SourceLeadClaimedDistribution = [],
    topClaimingAgents = [],
    recentActions = [],
    staleLeads = [],
  } = dashboardData;

  return (
    <div className='dashboard'>
      <Spinner isActive={loading} />
      <div className='dashboard__stats'>
        <StatCard
          label='Total shared leads'
          value={totalSharedLeads}
        />
        <StatCard
          label='Claimed leads'
          value={claimedLeads}
        />
        <StatCard
          label='Transacted leads'
          value={transactedLeads}
        />
        <StatCard
          label='Average claim time'
          value={avgClaimTime ? `${avgClaimTime} days` : '—'}
        />
        <StatCard
          label='Pool health'
          value={transactedPercentage ? `${transactedPercentage}%` : '—'}
          extra={leadPoolHealth ?? ''}
        />
      </div>

      <div className='dashboard__charts'>
        <div className='dashboard__card'>
          <DonutChart data={sourceDistribution} />
        </div>
        <div className='dashboard__card'>
          <BarChart data={SourceLeadClaimedDistribution} />
        </div>
      </div>

      <div className='dashboard__card full-width'>
        <AgentTable data={topClaimingAgents} />
      </div>

      <div className='dashboard__tables'>
        <div className='dashboard__card left-table'>
          <RecentLeadTable data={recentActions} />
        </div>
        <div className='dashboard__card right-table'>
          <StaleLeadsTable data={staleLeads} />
        </div>
      </div>
    </div>
  );
};

export default LeadxchangeDashboard;
